export const tamanhoFilterFields = [
  {
    name: "nome",
    label: "Tamanho",
    placeholder: "Buscar por tamanho...",
    type: "text" as const,
  },
  {
    name: "lojaId",
    label: "Loja",
    placeholder: "Selecione uma loja...",
    type: "select" as const,
  },
];
